import { Box } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { useApi } from '@app/hooks';

import { ChatContainer } from './components/chat-container';
import { PromptInput } from './components/prompt-input';
import { Message } from './types';

const MAX_MESSAGES = 20;

const addMessage = (messages: Message[], message: Message): Message[] => {
  return [
    ...(messages.length > MAX_MESSAGES ? messages.slice(1, messages.length) : messages), 
    message
  ];
};

export const SupportChat = () => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [loading, setLoading] = useState(false);
  const api = useApi();

  useEffect(() => {
    const saveMessages = localStorage.getItem('chat-messages');
    if (saveMessages) {
      setMessages(JSON.parse(saveMessages));
    }
  },[]);

  const onSubmit = async (message: string) => {
    setLoading(true);
    let _messages: Message[] = addMessage(messages, { id: Date.now(), message, from: 'user', date: new Date().toLocaleString() }); 
  
    setMessages(_messages);

    localStorage.setItem('chat-messages', JSON.stringify(_messages));
    const thread = localStorage.getItem('chat-previous-message') || undefined;
    const data = await api.aiAssistant.answers({
      query: message,
      previous_message_id: thread,
    });
    if (data.previous_message_id) {
      localStorage.setItem('chat-previous-message', data.previous_message_id);
    }
    _messages = addMessage(_messages, { id: Date.now(), message: data.answer, from: 'bot', date: new Date().toLocaleString() });
    localStorage.setItem('chat-messages', JSON.stringify(_messages));
    setMessages(_messages);

    setLoading(false);
  };

  return <Box display="flex" flexDirection='column' gap={2} flex={1} height='100%'>
    <ChatContainer messages={messages} loading={loading} />
    <PromptInput onSubmit={onSubmit} loading={loading} />
  </Box>;
};